import React from 'react'
import { useAuth0 } from "@auth0/auth0-react"
import { LogOut, User, Settings, LayoutDashboard } from 'lucide-react'
import { Button } from './button'
import { Avatar, AvatarFallback, AvatarImage } from "./avatar"
import { useTranslation } from '../../i18n'
import { useUserProfile } from "../../hooks/useUserProfile"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./dropdown-menu"
import { Link } from 'react-router-dom'

export default function ProfileMenu() {
  const { user, isAuthenticated, loginWithRedirect, logout } = useAuth0()
  const { t } = useTranslation()
  const { profile } = useUserProfile()

  const profileImage = profile?.profilePictureUrl || user?.picture
  const profileInitial = profile?.userFname?.charAt(0) || user?.name?.[0] || 'U'

  if (!isAuthenticated) {
    return (
      <Button onClick={() => loginWithRedirect()} variant="outline">
        {t('profileMenu.logIn')}
      </Button>
    )
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="relative h-8 w-8 rounded-full">
          <Avatar className="h-8 w-8">
            <AvatarImage src={profileImage} alt={user?.name} />
            <AvatarFallback>{profileInitial}</AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuItem asChild>
          <Link to="/user-profile" className="flex items-center">
            <User className="mr-2 h-4 w-4" />
            <span>{t('profileMenu.profile')}</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/dashboard" className="flex items-center">
            <LayoutDashboard className="mr-2 h-4 w-4" />
            <span>{t('profileMenu.dashboard')}</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/settings" className="flex items-center">
            <Settings className="mr-2 h-4 w-4" />
            <span>{t('profileMenu.settings')}</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem 
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          className="flex items-center"
        >
          <LogOut className="mr-2 h-4 w-4" />
          <span>{t('profileMenu.logOut')}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}